<template>
    <div>
        <div>
            <h2 class="title is-3 between-center">
                <span>Job Costing</span>
            </h2>

            <h2 v-if="mode === 'timelogs'" class="subtitle is-3 between-center" style="margin-bottom: 30px;">
                {{ currentProjectService }} Timelogs <a @click.prevent="mode = 'chart'" class="button is-default">Back</a>
            </h2>
            <br>
        </div>

        <div v-show="mode === 'chart'">
            <div class="columns toolbar-box is-multiline">

                <!--<div class="column is-6-tablet is-3-desktop">-->
                <!--<o-field>-->
                <!--<o-select :expanded="true" placeholder="Select Team" v-model="filters.team_id">-->
                <!--<option :value="null">Select Team</option>-->
                <!--<option :value="team.id" v-for="team in teams">{{ team.name }}</option>-->
                <!--</o-select>-->
                <!--</o-field>-->
                <!--</div>-->
                <!--<div class="column is-6-tablet is-3-desktop">-->
                <!--<multicomplete type="user" v-model="filters.users" placeholder="Select Users" />-->
                <!--</div>-->

                <div class="column is-6-tablet is-3-desktop">
                    <o-field>
                        <o-select :expanded="true" placeholder="Select Year" v-model="filters.year">
                            <option :value="null">All Years</option>
                            <option :value="year" v-for="year in years">
                                {{ year }}
                            </option>
                        </o-select>
                    </o-field>
                </div>
                <div class="column is-6-tablet is-3-desktop">
                    <o-field>
                        <o-select :expanded="true" placeholder="Select Month" v-model="filters.month" :disabled="!filters.year">
                            <option :key="month.id" :value="month.id" v-for="month in months">
                                {{ month.name }}
                            </option>
                        </o-select>
                    </o-field>
                </div>
            </div>

            <o-table
                class="is-responsive is-responsive-desktop"
                :data="jobCosting"
                :bordered="table.bordered"
                :striped="table.striped"
                :narrowed="table.narrowed"
                :checkable="false"
                :mobile-cards="table.mobileCards"
                :paginated="table.paginated"
                :pagination-simple="table.paginationSimple"
                :per-page="table.perPage"
                :default-sort="table.defaultSort"
                @click="handleServiceClick"
            >
                <template>
                    <o-table-column #default="{ row }" field="service" label="Service" :sortable="true">
                        {{ row.title }}
                    </o-table-column>
                    <o-table-column #default="{ row }" field="description" label="Notation" :sortable="true">
                      <b-quill :value="row.description"/>
                    </o-table-column>
                    <o-table-column #default="{ row }" field="budget" label="Budget" :sortable="true">
                        {{ $filters.currency(row.billed) }}
                    </o-table-column>
                    <o-table-column #default="{ row }" field="actual" label="Actual" :sortable="true">
                        {{ $filters.currency(row.expenses) }}
                    </o-table-column>
                    <o-table-column #default="{ row }" field="percentage" label="Percentage" :sortable="true">
                        {{ $filters.percentage(row.expenses, row.billed) }}
                    </o-table-column>
                </template>
            </o-table>
        </div>

        <div v-show="mode === 'timelogs'">
            <o-table
                    class="is-responsive is-responsive-desktop"

                    v-if="timelogs.length"
                    :data="timelogs"

                    :bordered="table.bordered"
                    :striped="table.striped"
                    :narrowed="table.narrowed"
                    :checkable="false"
                    :mobile-cards="table.mobileCards"
                    :paginated="table.paginated"
                    :pagination-simple="table.paginationSimple"
                    :per-page="table.perPage"
                    :default-sort-direction="table.defaultSortDirection"
                    :default-sort="table.defaultSort"
                    @sort="onSort"
            >
                <template slot-scope="props">
                    <template v-for="col in tableColumns" :key="col.field">
                        <o-table-column
                                :field="col.field"
                                :label="col.field === 'actions' ? '' : col.label"
                                #default="{ row }"
                                :sortable="col.sortable"
                        >
                            <router-link v-if="col.field === 'user_id'" :to="{ name: 'users.show', params: { slug: row.user_id } }">
                                {{ $filters.valueOrDefault(userNameById(row.user_id), '–') }}
                            </router-link>
                            <router-link v-if="col.field === 'project_id'" :to="{ name: 'projects.show', params: { slug: row.project_id } }">
                                {{ $filters.valueOrDefault(projectNameById(row.project_id), '–') }}
                            </router-link>
                            <span v-if="col.field === 'hourly_rate'">{{ $filters.currency(row.hourly_rate) }}</span>
                            <span v-if="col.field === 'cost'">{{ $filters.currency(row.cost) }}</span>
                            <span v-if="col.field === 'focus'">{{ timelogActivityName(row) }}</span>
                            <span v-if="col.field === 'time'">{{ row.time }}</span>
                            <span v-if="col.field === 'note'" v-html="row.note"></span>
                            <span v-if="col.field === 'activity_type'">{{ row.activity_type }}</span>
                            <span v-if="col.field === 'activity'">{{  $filters.valueOrDefault(dictionaryEntryNameByTypeAndId('timelog-activity', row.activity_name)) }}</span>
                            <span v-if="col.field === 'date'">{{ $filters.date(row.created_at) }}</span>
                            <span v-if="col.field === 'created_at'">{{ $filters.date(row.created_at) }}</span>
                            <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                              <template #trigger>
                                <button class="button">
                                  <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                                </button>
                              </template>
                                <o-dropdown-item has-link><a @click="openTimeLogModal(row)">View</a></o-dropdown-item>
                            </o-dropdown>
                        </o-table-column>
                    </template>
                </template>
            </o-table>
        </div>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTimeLogModalActive" has-modal-card>
            <time-log-modal :timelog-prop="timelog" :project-id="currentProjectId" />
        </o-modal>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Chart from './../../dashboards/tabs/job-costing/Chart'
    import Table from './../../../mixins/Table'

    export default {
        props: [],

        mixins: [Table],

        components: {
            Chart
        },

        computed: {
            ...mapGetters([
                'currentProjectId',
                'months',
                'years',
                'userNameById',
                'projectNameById',
                'timelogActivityName',
                'dictionaryEntryNameByTypeAndId',
            ]),

            isResetFiltersButtonVisible() {
                return true
            },
        },

        watch: {
            'filters.month'() {
                this.fetchData()
            },
            'filters.year'() {
                this.fetchData()
            }
        },

        data() {
            return {
                tableName: 'timelogs-index',

                urlFilter: {
                    enabled: false,
                },

                filters: {
                    year: null,
                    month: moment().format('MM'),
                    // team_id: null,
                    // users: []
                },

                mode: 'chart',

                currentProjects: [],
                currentProjectService: null,

                jobCosting: [],

                timelogs: [],
                timelog: null,
                isTimeLogModalActive: false
            }
        },

        mounted() {
            this.fetchData()
        },

        methods: {
            fetchData() {
                axios.get(`/api/billings/job-costing-services`, {params: _.merge({project_id: this.currentProjectId}, this.filters)})
                    .then(res => {
                        this.jobCosting = _.sortBy(res.data.data, (service) => {
                            return _.isString(service.id) ? parseInt(service.id.replace('s', 10000000)) : service.id
                        })

                        return res
                    })
            },

            handleServiceClick(row) {
                axios.get(`/api/timelogs`, {params: {project_service_id: row.id}})
                    .then(res => {
                        if (res.data.data.length) {
                            this.currentProjectService = row.title
                            this.timelogs = res.data.data
                            this.mode = 'timelogs'
                        } else {
                            this.errorMessage('Project service doesn\'t have billed time yet')
                        }

                        return res
                    })
            },

            openTimeLogModal(timelog) {
                this.timelog = timelog
                this.isTimeLogModalActive = true
            }
        }
    }
</script>
